import { useTranslation } from 'react-i18next';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormTextInput from 'components/FormTextInput/TypedFormTextInput';

export type FacebookConfig = {
  enabled: boolean;
  id: string | null;
  secret: string | null;
};

type FacebookConfigCardProps = {
  config: FacebookConfig;
  classes: { [key: string]: string };
  onChange: (config: FacebookConfig) => void;
};

const FacebookConfigCard = ({
  config,
  classes,
  onChange,
}: FacebookConfigCardProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardBody>
        <LabeledCheckbox
          checked={config.enabled}
          onChange={() => onChange({ ...config, enabled: !config.enabled })}
          label={t('brands.newBrandForm.viaFacebook')}
        />
        <FormTextInput
          label="Facebook APP ID"
          classes={classes}
          name="facebookAppId"
          value={config.id}
          maxLength={128}
          handleChange={e => onChange({ ...config, id: e.target.value })}
          inputSize={6}
        />
        <FormTextInput
          label="Facebook secret key"
          classes={classes}
          name="facebookAppSecret"
          value={config.secret}
          maxLength={64}
          handleChange={e => onChange({ ...config, secret: e.target.value })}
          inputSize={6}
        />
      </CardBody>
    </Card>
  );
};

export default FacebookConfigCard;
